webpackJsonp([204811817341229],{

/***/ 393:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Jeff Chan","author":"Jeff Chan"}},"markdownRemark":{"id":"/opt/build/repo/src/pages/blog-redux/index.md absPath of file >>> MarkdownRemark","html":"<p>The last time I had a <a href=\"https://web.archive.org/web/20090227035418/http://jeffchan.org:80/\">public blog</a> was in high school. The blog was titled <a href=\"https://web.archive.org/web/20060613060009/http://jeffchan.org:80/\"><em>The Jeff Channel</em></a>, and <a href=\"https://web.archive.org/web/20060210182733/http://jeff.rsbandb.com:80/\"><em>The Geeky Jeffy Zone</em></a> prior to that. Still debating whether to bring one of those names back.</p>\n<p>I intend to write about programming, startups, engineering management, and books. Stay tuned!</p>","frontmatter":{"title":"Blog Redux","date":"August 03, 2018"}}},"pathContext":{"slug":"/blog-redux/","previous":null,"next":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-redux-422d51b1f0dcba745998.js